import type { Theme } from '@logto/schemas';

type Props = {
  readonly className?: string;
  readonly theme: Theme;
};

/** Creator 自托管版不渲染 Logto 默认页脚。 */
const LogtoSignature = (_props: Props) => null;

export default LogtoSignature;
